import * as CONST from "./actionTypes";

export const getDisputes = (payload, params, callBack) => {
  return {
    type: CONST.GET_DISPUTES,
    payload,
    params,
    callBack,
  };
};

export const getDisputesSuccess = (payload, callBack) => {
  return {
    type: CONST.GET_DISPUTES_SUCCESS,
    payload,
    callBack,
  };
};

export const getDisputesFail = (payload, callBack) => {
  return {
    type: CONST.GET_DISPUTES_FAIL,
    payload,
    callBack,
  };
};

// by id

export const getDisputesView = (payload, callBack) => {
  return {
    type: CONST.GET_DISPUTE_VIEW,
    payload,
    callBack,
  };
};

export const getDisputesViewSuccess = (payload, callBack) => {
  return {
    type: CONST.GET_DISPUTE_VIEW_SUCCESS,
    payload,
    callBack,
  };
};

export const getDisputesViewFail = (payload, callBack) => {
  return {
    type: CONST.GET_DISPUTE_VIEW_FAIL,
    payload,
    callBack,
  };
};
